// extracted by mini-css-extract-plugin
export default {"accounts_list":"virtualNumbers_accounts_list__ZIADk","loader_wrapper":"virtualNumbers_loader_wrapper__TS9ML","centeredWrapper":"virtualNumbers_centeredWrapper__8VKv+"};